import axios from 'axios';
import { Modal } from 'antd-mobile';
import Axios from 'axios';

const errorMessages = res => `${res.status} ${res.statusText}`;

function handle401(res) {
    if (res.status === 401 && !res.url.match('auth')) {
        return Promise.reject(errorMessages(res));
    }
    return res;
}

function handleErrors(res) {
    console.log(res, 'eeee');
    // if (!res.ok) {
    //     return { isSuccess: false, content: res.statusText };
    // }
    return res.data;
}

function handleCodeError(res) {
    if (res.result && res.result.code === -1) {
        // Modal.error({
        //     content: res.result.errorMessage || '数据请求异常，请检查网络链接，或联系管理人员',
        // });
        return res;
        // Promise.reject(errorMessages(res));
    }
    return res;
}

function generalMessage(res) {
    return res;
}

/**
 * 发送异步请求
 * @param url
 * @param option
 * @returns {*|Promise.<TResult>}
 * 用法：
 * const option = {
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        credentials: 'include'
    };
 return customFetch('/api/', option);
 */
export default function customFetch(url, option) {
    console.log(process.env, 'process.env');
    const backend = process.env.REACT_APP_BACKEND1;
    if (!backend) {
        throw new Error('backend ENV variable undefined');
    }
    const urls = url.indexOf('/interface') === -1 ? url : backend + url.slice(10);
    console.debug(urls, 'dddddd', url);
    return axios
        .request({
            url: urls,
            ...option,
        })
        .then(handle401)
        .then(handleErrors)
        .then(handleCodeError)
        .then(generalMessage);
}
